(function ($) {
    'use strict';
    const keyCodes = {
        Backspace: 8,
        Tab: 9,
        Enter: 13,
        Esc: 27,
        Delete: 46
    };
    $.widget("fd.control_number", {
        options: {
            parentid: null,
            callback: function () { },
            precision: 0,
            allowclear: false,
            min: null,
            max: null,
            editfactor: 1 // If set(.01, 100) the value in the input would be adjusted by this factor when displayed and reverted when the form is posted. This min and max apply to the display value. This is useful for editing percentages for example.
        },
        initial: function (value) {
            if (value === undefined) {
                return this.options.initial;
            }

            this.options.initial = value;
            this.element.data('initial', value).attr('data-initial', value);

            return this;
        },
        _create: function () {
            if (!this.options.parentid) {
                this.options.parentid = this.element.closest('[data-fd-parentid]').data('fd-parentid');
            }

            if (this.options.editfactor != 1) {
                this.input = this.element.clone().removeAttr('name id data-fd-control').val(this.element.val() * this.options.editfactor).insertAfter(this.element);
                this.element.addClass('d-none');
            }

            // Convert numeric options
            this.options.min = this.options.min !== null ? Number(this.options.min) : null;
            this.options.max = this.options.max !== null ? Number(this.options.max) : null;
            
            this.initial(this.element.val())._validate(this.element.val(), false)._setEvents();
        },
        _handleFocus: function (event) {
            const self = event.data;
            self.initial(self.element.val());
        },
        _handleBlur: function (event) {
            const self = event.data;
            self._handleSubmit(event);
        },
        _handleKeypress: function (event) {
            const self = event.data;
            var element = self.options.editfactor != 1 ? self.input : self.element;
            if (event.which === keyCodes.Esc) {
                element.val(self.options.initial).focus();
                return;
            }
            if (event.which === keyCodes.Enter) {
                self._handleSubmit(event);
                if (self.element.closest('form').control_form('instance') && self.element.closest('form').control_form('option', 'onchange')) {
                    self.element.trigger('change2.onenter');
                }
                return;
            }

            if (!String.fromCharCode(event.which).match(/^\-?[0-9]*\.?[0-9]*$/)) {
                event.preventDefault();
                return false;
            }
        },
        _handlePaste: function (event) {
            const self = event.data;
            event.preventDefault();

            let clipboardData = event.originalEvent.clipboardData || window.clipboardData;
            const pastedText = clipboardData.getData('Text');

            self._validate(pastedText);
        },
        _handleSubmit: function (event) {
            this._validate();
            if (Number(this.options.initial) !== Number(this.element.val()) && this.options.callback && typeof (this.options.callback) === 'function') {
                this.options.callback.call(this, { parentid: this.options.parentid, value: this.element.val() }, event);
            }
        },
        _setEvents: function () {
            var element = this.options.editfactor != 1 ? this.input : this.element;
            element.off('focus.fdcontrol blur.fdcontrol keyup.fdcontrol paste.fdcontrol')
                .on('focus.fdcontrol', null, this, this._handleFocus)
                .on('blur.fdcontrol', null, this, this._handleBlur)
                .on('keypress.fdcontrol', null, this, this._handleKeypress)
                .on('paste.fdcontrol', null, this, this._handlePaste);
        },
        _setOption: function (key, value) {
            this.options[key] = value;
        },
        _validate: function (newValue, validate = true) {
            var element = this.options.editfactor != 1 ? this.input : this.element;

            let value;
            if (newValue) {
                value = newValue.replace(/\,/g, '');
            } else {
                value = element.val().replace(/\,/g, '');
            }

            if (this.options.allowclear && (value === "" || value === undefined || value === null)) {
                element.val(null);
                this.element.val(null);
            } else if (!value.match(/^\-?[0-9]*\.?[0-9]*$/)) {
                element.val(this.initial() * this.options.editfactor)
                this.element.val(this.initial());
            } else {
                value = Number(value);

                if (this.options.min !== null && value < Number(this.options.min)) {
                    value = this.options.allowclear ? null : Number(this.options.min);
                } else if (this.options.max !== null && value > Number(this.options.max)) {
                    value = this.options.allowclear ? null : Number(this.options.max);
                }

                if (value == null) {
                    element.val(null);
                    this.element.val(null);
                }
                else if (this.options.precision !== undefined) {
                    element.val(value.toFixed(this.options.precision));

                    if (this.options.editfactor != 1) {
                        var factorOffset = this.options.editfactor < 1 ? (-1 * this.options.editfactor.toString().length + 1) : this.options.editfactor.toString().length;
                        this.element.val((value / this.options.editfactor).toFixed(this.options.precision + factorOffset));
                    }
                } else {
                    element.val(value);
                    this.element.val(value / this.options.editfactor);
                }
            }

            if (validate && this.element.valid) {
                this.element.valid(); // re-evaluate validatity 
            }

            return this;
        }
    });
}(jQuery));